<template>
    <div id="main" class="success_container">
        <div>
            <div class="success_png">
                <!-- <img src="@/assets/image/return/Group 49@2x.png"> -->
                <svg width="192" height="192" viewBox="0 0 300 300" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M150 300C232.843 300 300 232.843 300 150C300 67.1573 232.843 0 150 0C67.1573 0 0 67.1573 0 150C0 232.843 67.1573 300 150 300Z" fill="#1BB84B"/>
                  <path d="M69.4521 151.29L122.552 204.39L229.875 95.8999" stroke="white" stroke-width="30" stroke-linecap="round"/>
                </svg>
            </div>
            <div class="success_value">
                <p>{{$t('success.step1SuccessTitle')}}</p>
            </div>
            <div class="success_value">
                <p>{{$t('success.step1SuccessMsg')}}</p>
            </div>
            <div class="success_id" v-if="expressNumber">
              {{$t('success.successID')}}: {{`&nbsp;${expressNumber}`}}
            </div>
            <div style="min-height: calc(30vh);"></div>
            <div class="action-button">
                <button class="details_bt_w" @click="back()">{{$t('common.Back')}}</button>
                <button v-if="next" class="details_bt_b" @click="nextAction()">{{$t('success.step1ScanNext')}}</button>
            </div>

            <bottom></bottom>
        </div>
    </div>
</template>

<script>
import bottom from '../Bottom.vue'

export default {
  name: 'EditRemark',
  data () {
    return {
      showNote: false,
      title: null,
      titleDisplay: null,

      action: null,
      next: false,
      otherNumber: null,
      oldScanResult: null,
      isNeedScanOtherNumber: false
    }
  },
  watch: {
    title (val) {
      if (val === 'MerchantStoreSuccess' || val === 'CustomerStoreSuccess') {
        this.showNote = true
      } else {
        this.showNote = false
      }
    }
  },
  beforeCreate: function () {
    document.getElementsByTagName('body')[0].style = 'background-color: #f8f8f8;'
  },
  created () {
    let vue = this
    let param = this.$route.query
    this.title = this.$route.query.msg
    this.action = this.$route.query.action
    this.next = this.$route.query.next !== 'undefined' && this.$route.query.next
    this.original_action = this.$route.query.original_action

    this.otherNumber = this.$route.query.otherNumber
    this.oldScanResult = this.$route.query.oldScanResult
    this.isNeedScanOtherNumber = this.$route.query.isNeedScanOtherNumber
  },
  components: {bottom},
  methods: {
    back () {
      this.$router.go(-1)
    },
    nextAction () {
      // this.$router.push(`/barcode?flow=${flow}&step=1&action=collectingPointStoreExpress&next=true`)
      let vue = this
      console.log('nextAction', this.$route.query, {
        query: {
          flow: 'WITHOUT_LABEL',
          step: '2',
          action: vue.action,
          next: vue.next,
          otherNumber: vue.otherNumber,
          oldScanResult: vue.oldScanResult,
          isNeedScanOtherNumber: vue.isNeedScanOtherNumber
        }
      })
      // return
      vue.$router.push({
        name: 'BarcodeWithoutLabel',
        query: {
          flow: 'WITHOUT_LABEL',
          step: '2',
          action: vue.action,
          next: vue.next,
          otherNumber: vue.otherNumber,
          oldScanResult: vue.oldScanResult,
          isNeedScanOtherNumber: vue.isNeedScanOtherNumber
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
    .success_png {
        // width: 1.5rem;
        // height: 1.5rem;
        margin: 0 auto;
        margin-top: 11.87%;
        // margin-bottom: 0.5rem;
        margin-bottom: 0.25rem;

        display: flex;
        justify-content: center;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .success_value {
        margin: 0 auto;
        text-align: center;
        min-height: 0.43rem;
        white-space: pre-line;
        font-weight: 900;

        p {
            font-size: 0.3rem;
            color: #000;
            line-height: 0.355rem;
            font-weight: bold;
        }
    }

    .success_id {
      margin-top: 20px;
      display: flex;
      justify-content: center;
      text-decoration: none;
      font-size: 0.15rem;
    }

    .success_text {
        margin: 0 auto;
        width: 2.72rem;
        height: 1.23rem;
        background: #FFFFFF;
        border: 1px solid #707070;
        border-radius: 0.1rem;
        margin-top: 0.415rem;
        padding: 0.135rem 0.185rem;
        text-align: left;
        margin-bottom: 3rem;
        white-space: pre-wrap;

        p {
            font-size: 0.15rem;
            font-weight: 900;
            line-height: 0.18rem;
            color: #ACACAC;
        }
    }

    .details_bt_w {
        width: 82%;
        height: 0.58rem;
        // background: rgba(255, 255, 255, 1);
        background: var(--primary-inverted-button-bg-color);
        box-shadow: 0rem 0.05rem 0.1rem rgba(0, 0, 0, 0.16);
        opacity: 1;
        border-radius: 0.42rem;
        margin: 0.805rem 9% 0;
        border: none;
        // color: rgba(5, 36, 96, 1);
        color: var(--primary-inverted-button-text-color);
        line-height: 0.235rem;
        font-size: 0.2rem;
        font-weight: bold;
    }

    .details_bt_b {
        width: 82%;
        height: 0.58rem;
        // background: linear-gradient(113deg, rgba(5, 36, 96, 1) 0%, rgba(31, 157, 197, 1) 100%);
        // background: linear-gradient(to right, #191E96 , #00BEF5 );
        background: var(--primary-button-bg-color);
        box-shadow: 0rem 0.05rem 0.1rem rgba(5, 36, 96, 0.3);
        border-radius: 0.42rem;
        margin: 0.1rem 9% 0;
        border: none;
        // color: #ffffff;
        color: var(--primary-button-text-color);
        line-height: 0.235rem;
        font-size: 0.2rem;
        font-weight: bold;
    }

    .scan-note {
        position: absolute;
        padding-left: 0.15rem;
        padding-right: 0.15rem;
        font-weight: 400;
        color: #5A5A5A;
        top: 4.4rem;
        left: 1rem;
        width: auto;
        height: 0.3rem;
        line-height: 0.3rem;
        background: #fff;
        box-shadow: -0.03rem 0.06rem 0.09rem rgba(0, 0, 0, 0.16);
        opacity: 1;
        border-radius: 0.13rem;
        font-size: 0.15rem;
        z-index: 5;
    }

    .scan-icon {
        height: 50%;
    }
    .curtain{
        z-index: 2;
        width:100%;
        height: 100%;
        position:fixed;
        top: 0;
        background: #000;
        opacity:0.5;
        left: 0;
    }
    .remark_details_edit {
        z-index: 3;
        width: 3.415rem;
        height: 3.375rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-color: #ffffff;
        box-shadow: 0rem 0rem 0.1rem rgba(0, 0, 0, 0.16);
        border-radius: 0.1rem;
    }
    .remark_edit_title {
        color: #1F8DC5;
        line-height: 0.18rem;
        height: 0.18rem;
        font-size: 0.15rem;
        margin-left: 4.5%;
        padding-top: 0.245rem;
        font-weight: 500;
    }
    .remark_edit_input {
        height: 2.025rem;
        border: 1px solid rgba(112, 112, 112, 1);
        border-radius: 0.1rem;
        width: 77.5%;
        margin-left: 4.5%;
        margin-top: 0.165rem;
        font: 400 0.15rem Rubik;
        color: #000;
        line-height: 0.18rem;
        padding: 0.12rem 0.17rem;
        display: inline-block;
    }
    .save-cancel-box{
        display: flex;
        flex-direction: row-reverse;
    }
    .remark_edit_a {
        height: 0.18rem;
        font-size: 0.15rem;
        margin-top: 0.1rem;
        display: inline-block;
        font-weight: 400;
        line-height: 0.18rem;
    }

    .remark_edit_a_blue {
        margin-right: 0.3rem;
        margin-left: 0.3rem;
        color: #1F8DC5;
    }

    .remark_edit_a_gray {
        color: #ACACAC;
    }
    .remark_scan-note{
        position: absolute;
        padding-left: 0.15rem;
        padding-right: 0.15rem;
        font-weight: 400;
        color:#5A5A5A;
        top: 2.4rem;
        left: 50%;
        transform: translate(-50%, 0%);
        /* left: 0.7rem; */
        /* width: auto; */
        width: max-content;
        height:0.3rem;
        line-height: 0.3rem;
        background:#fff;
        box-shadow:-0.03rem 0.06rem 0.09rem rgba(0,0,0,0.16);
        opacity:1;
        border-radius:0.13rem;
        font-size: 0.15rem;
    }
    .remark_scan-icon{
        height: 50%;
    }
    .action-button{
        // position: fixed;
        position: sticky;
        bottom: 0.4rem;
        width: 100%;
    }
    .bottom{
        position: fixed;
        bottom: 0;
    }
    .success_container{
      height: 100vh;
      height: 100svh;
      height: 100dvh;
    }
</style>



// WEBPACK FOOTER //
// src/components/Return/Step1Success.vue